<template>
  <div class="mb-3 border-bottom">
    <div v-if="input.variable != null">
      <div v-if="variableContentType == 'empty' || variableContentType == 'auto'">
        <div v-if="input.variable.type == 'text' && input.variable.validationType == 'text'" class="row mx-0">
          <div class="col ps-0 my-auto">
            <p><i>Deutsch</i></p>
            <TextInput
              :index="index"
              v-model="input.value"
              :label="input.variable.titel + ' (' + input.variable.platzhalter + ')'"
              :min="input.variable.minLength"
              :max="input.variable.maxLength"
              :inputType="input.variable.validationType"
            />
          </div>

          <div class="col pe-0 my-auto">
            <p><i>Englisch</i></p>
            <TextInput
              :index="index"
              v-model="input.valueEN"
              :label="input.variable.titel + ' (' + input.variable.platzhalter + ')'"
              :min="input.variable.minLength"
              :max="input.variable.maxLength"
              :inputType="input.variable.validationType"
            />
          </div>
        </div>

        <div v-else-if="input.variable.type == 'text'">
          <TextInput
            :index="index"
            v-model="input.value"
            :label="input.variable.titel + ' (' + input.variable.platzhalter + ')'"
            :min="input.variable.minLength"
            :max="input.variable.maxLength"
            :inputType="input.variable.validationType"
          />
        </div>

        <div v-else-if="input.variable.type == 'date' && input.variable.validationType == 'today'" class="mb-3">
          <label :for="'input-' + index" class="form-label">{{ input.variable.titel }} ({{ input.variable.platzhalter }})</label>
          <p>Diese Variable wird beim Erstellen eines Dokuments automatisch mit dem aktuellen Datum ausgefüllt.</p>
          <input :type="input.variable.type" class="form-control" :id="'input-' + index" v-model="input.value" disabled />
        </div>

        <div v-else class="mb-3">
          <label :for="'input-' + index" class="form-label">{{ input.variable.titel }} ({{ input.variable.platzhalter }})</label>
          <input :type="input.variable.type" class="form-control" :id="'input-' + index" v-model="input.value" />
        </div>
      </div>

      <div v-else-if="variableContentType == 'select'" class="mb-3">
        <label :for="'input-' + index" class="form-label">{{ input.variable.titel }} ({{ input.variable.platzhalter }})</label>
        <select class="form-select" :id="'input-' + index" v-model="input.value" @change="setSelectInput()">
          <option value="">Option auswählen</option>
          <option v-for="value in input.variable.values" :key="value.id" :value="value.value">
            {{ value.value }}<span v-if="value.valueEN != undefined && value.valueEN != ''"> / {{ value.valueEN }}</span>
          </option>
        </select>
      </div>

      <div v-else-if="variableContentType == 'summe'" class="mb-3">
        <label :for="'input-' + index" class="form-label">{{ input.variable.titel }} ({{ input.variable.platzhalter }})</label>
        <p>Der Inhalt dieser Variable wird automatisch berechnet, wenn auf "Speichern" geklickt wird.</p>
        <input type="text" class="form-control" :id="'input-' + index" v-model="input.value" disabled />
      </div>
    </div>

    <div v-else class="alert alert-warning">Ungültige Variable (Variable ID {{ input.variableid }})</div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, PropType } from 'vue';

  import TextInput from '../FormInputs/TextInput.vue';

  import { Input } from '@/models/VertragModels';
  //#endregion

  const { input, index } = defineProps({
    input: {
      type: Object as PropType<Input>,
      required: true,
    },

    index: {
      type: Number,
      required: true,
    },
  });

  const variableContentType = computed(() => {
    if (input.variable != null) {
      if (input.variable.herkunft != '') {
        return 'auto';
      } else if (input.variable.values.length > 0 && input.variable.values[0].type == 'select') {
        return 'select';
      } else if (input.variable.values.length > 0 && input.variable.values[0].type == 'summe') {
        return 'summe';
      } else {
        return 'empty';
      }
    } else {
      return 'empty';
    }
  });

  function setSelectInput() {
    if (input.variable != null && input.variable.values.length > 0) {
      const selectedValue = input.variable.values.find((v) => v.value === input.value);
      if (selectedValue) {
        input.valueEN = selectedValue.valueEN || '';
      } else {
        input.valueEN = '';
      }
    }
  }
</script>
